import { CarFront, Clock3, MapPin, Phone, Star } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function VisitSection({ phoneTel, mapsUrl }) {
  return (
    <section className="editorial-section visit-section" id="visit" aria-labelledby="visit-heading">
      <div className="section-inner visit-layout">
        <Reveal>
          <div className="visit-copy">
            <div className="section-kicker">06 / Concierge & access</div>
            <h2 id="visit-heading">Come hungry.<br />Leave glowing.</h2>
            <p>RingRoad, Dandupur Rd, Chandmari, Varanasi, Uttar Pradesh 221003. Find the lights, pull into your own parking, and let the evening take its time.</p>
            <div className="visit-actions">
              <a className="button visit-button" href={phoneTel} data-testid="visit-call-button"><Phone aria-hidden="true" /> Call 080040 80054</a>
              <a className="button button-ghost visit-map-button" href={mapsUrl} target="_blank" rel="noreferrer" data-testid="visit-directions-button"><MapPin aria-hidden="true" /> Get directions</a>
            </div>
            <div className="visit-teaser" data-testid="visit-trust-language-teaser">
              <div className="visit-teaser-item"><span>01 / Trust</span><p>4.0 from 1,076 Google reviews.<br />Guest stories coming soon.</p></div>
              <div className="visit-teaser-item"><span>02 / Welcome</span><p>English now.<br />Hindi welcome coming soon.</p></div>
            </div>
          </div>
        </Reveal>
        <Reveal delay={120}>
          <div className="visit-facts" data-testid="visit-facts">
            <div className="visit-fact" data-testid="visit-address-info"><div className="visit-label">Address</div><p>RingRoad, Dandupur Rd, Chandmari<br />Varanasi, Uttar Pradesh 221003</p></div>
            <div className="visit-fact" data-testid="visit-hours-info"><div className="visit-label">Hours</div><p><strong>Open today</strong><br />Closes at 11 pm</p></div>
            <div className="visit-fact" data-testid="visit-parking-info"><div className="visit-label">Arrival</div><p className="icon-copy"><span><CarFront size={17} aria-hidden="true" /> Big private car parking facility</span></p></div>
            <div className="visit-fact" data-testid="visit-service-info"><div className="visit-label">At the table</div><p className="icon-copy icon-copy-stack"><span><Star size={17} fill="currentColor" aria-hidden="true" /> 4.0 · 1,076 Google reviews</span><span><Clock3 size={17} aria-hidden="true" /> All you can eat · Fireplace · Private dining room</span></p></div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
